(function ( $ ){

	var defaults = {

		url: "https://api.instagram.com/v1/users/{{user_id}}/media/recent/?client_id={{client_id}}&callback=?&count={{count}}",

		parameters: {
			client_id: null,
			user_id: null,
			count: 6
		}

	}

	$.fn.instagramFeed = function(options){

		var options = options || {};

		return this.each(function(){

			var kontext = $(this);

				/* Einstellungen über Data-Attribute */

			var data = {

				parameters: {
					client_id: kontext.data("client-id"),
					user_id: kontext.data("user-id"),
					count: kontext.data("count")
				}

			}

				/* Einstellungen vereinen */

			var settings = $.extend({}, defaults, options, data);

			new Feed(kontext, settings);

		});

	};


	var Feed = function(kontext, settings){

		this.kontext = kontext;
		this.settings = settings;

		if (typeof settings.parameters.client_id === "undefined"){
			this.zeigeFehler("Der Feed kann nicht angezeigt werden: Keine Client-ID angegeben.");
			return false;
		} else if (typeof settings.parameters.user_id === "undefined"){
			this.zeigeFehler("Der Feed kann nicht angezeigt werden: Keine User-ID angegeben.");
			return false;
		}

			/* API-Endpoint */

		var url = settings.url;

		for (var id in settings.parameters){
			url = url.replace(new RegExp("\{\{" + id + "\}\}"), settings.parameters[id]);
		}

		this.settings.url = url;

		console.log(url);

		this.laden();

	};

	Feed.prototype.laden = function(){

		var self = this;

		$.getJSON(this.settings.url, function(antwort){

			if (typeof antwort.data === "object" && antwort.data.length !== 0){

				for (var index = 0; index < antwort.data.length; index++){

					var bild = $('<img/>').appendTo(self.kontext).hide().attr("src", antwort.data[index].images.low_resolution.url);

					if (navigator.userAgent.match(/msie/i) !== null){
						bild.show();
					} else {
						bild.load(function(){
							$(this).fadeIn();
						});
					}

				}

				self.kontext.removeClass("js-hidden");

			} else {
				$(".instagram-image", self.kontext).hide();
				$(self.kontext).append('<div class="image-wrapper"><span class="meldung">Es wurden keine Bilder gefunden :(</span></div>');
			}

		});

	};

	Feed.prototype.zeigeFehler = function(text){

		if (typeof console !== "undefined" && typeof console.log !== "undefined"){
			console.log("instagramFeed: " + text);
		}

	};

}( jQuery ));